import {Component, OnInit} from '@angular/core';
import {EventsService} from '../../events.service';
import {EventDialogComponent} from "../../../Dialogs/event-dialog/event-dialog.component";
import {MatDialog} from '@angular/material/dialog';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-yalla-awc',
  templateUrl: './yalla-awc.component.html',
  styleUrls: ['./yalla-awc.component.scss']
})
export class YallaAwcComponent implements OnInit {

  dialogRef;

  constructor(public dialog: MatDialog,private titleService:Title) {
    this.titleService.setTitle('Yalla Arabian Cup')
  }

  ngOnInit() {

  }

  multidialog(dialogType) {
    if (this.dialogRef)
      this.dialogRef.close('')
    this.dialogRef = this.dialog.open(EventDialogComponent, {
      data: {
        type: dialogType
      },
      width: '500px',
      height:'500px'
    });
  }
}
